//*************************************************************************************
//* WaMS Component Framework - app.grid.js
//* Version 0.22
//* Author: Damian Koch
//* Component framework grids plugin
//* Requires jQuery, WaMS Component Framework
//* 
//* This component adds some grid features.  Any component with 'component-grid' in data-role
//* will be checked for [data-role="sort-action"] on sorting controls, and [data-role="filter-action"]
//* on filtering controls.
//* 
//* 04/18/22 DBK: Updates to support component framework 1.07
//* 07/07/22 BWH: Updates Keypress event handlers
//*************************************************************************************


app.grids = (function () {
    var myGrids = {
        Init: function () {
            this.initGridComponents();
            this.initPageGridActions();
            $(document).on("component-init-complete", function (e, component) { app.grids.initGridComponent(component); });
            $(document).on("component-action-init-complete", function (e, component) { app.grids.initPageGridAction(component); });
        },
        initGridComponents: function () {

            //This entire mess can be cleaned up if components get identified by guid
            var gridComponents = new Array();
            $('[data-role~="component-grid"]').each(function (i, gridElement) {
                gridComponents.push($(gridElement).data('component-type'));
            });
            gridComponents = $.unique(gridComponents);
            $.each(gridComponents, function (i, componentType) {
                var grids = app.page.allComponents[componentType];
                grids.forEach(function (grid) {
                    app.grids.initGridComponent(grid);
                });
            });

            $(document).on("component-bind-view-mode-complete", function (e, component) {
                //app.util.console.log("component-bind-view-mode-complete triggered: " + component.type);
                if (component.el.data('role').indexOf('component-grid')) {
                    $('[data-role="sort-action"]', component.el).attr('tabindex', '0');
                    $('[data-role="sort-action"]', component.el).attr('role', 'button');
                    $('[data-role="sort-action"]', component.el).on('click', $.proxy(component.sortGrid, component));
                    $('[data-role="dropdown-all"]', component.el).on('change', $.proxy(component.changeAllDropdown, component));
                    $('[data-role="textbox-all"]', component.el).on('keyup', $.proxy(component.changeAllTextbox, component));
                    $('[data-role="check-all"]', component.el).on('click', $.proxy(component.checkAll, component));
                    $('[data-role="sort-action"]', component.el).keypress(function (e) {
                        var code = e.key;
                        if (code === "Enter" || code === "Space") {
                            $(this).click();
                        }
                    });
                    $('[data-role="grid-page-action"]', component.el).on('click', $.proxy(component.pageGrid, component));
                    //Not sure why this was here. Was added in Study Abroad.
                    //app.input.initDatePicker(document);
                }
            });
        },
        initGridComponent: function (gridComponent) {
            gridComponent.selectors.table = 'table';
            gridComponent.selectors.filterForm = 'form[data-role~="filter-grid"][data-component-form-target~="' + gridComponent.type + '"]';
            gridComponent.selectors.pageSize = '[data-role~="grid-page-size"][data-component-form-target="' + gridComponent.type + '"]';
            gridComponent.selectors.showForResults = '[data-role~="grid-show-for-results"][data-component-form-target~="' + gridComponent.type + '"]';

            if ($('[data-role~="component"]', gridComponent.el).length) {
                gridComponent.selectors.rows = 'tbody:not([data-component-role="noResults"])';
            }
            else {
                gridComponent.selectors.rows = 'tbody > tr:not([data-component-role="noResults"])';
            }

            gridComponent.gridType = gridComponent.el.data('grid-type') || 'client';

            if (gridComponent.gridType === 'client') {
                gridComponent.filterGrid = function () {
                    var context = $(this.selectors.table, this.el);
                    var rows = $(this.selectors.rows, context);

                    rows.show();

                    $(':input', this.selectors.filterForm).each(function (i, e) {
                        var el = $(e);
                        if (el.val() !== '') {
                            var field;

                            if (el.data('target')) {
                                field = '[data-label="' + el.data('target') + '"]';
                            }
                            else {
                                field = '';
                            }

                            var values = el.val().toUpperCase().split(/\s+/);
                            rows.each(function (i, e) {
                                var hide = false;

                                $.each(values, function (index, v) {
                                    if ($(field + ':icontains("' + v + '")', e).length < 1) {
                                        hide = true;
                                        return;
                                    }
                                });
                                if (hide) {
                                    $(e).hide();
                                }
                            });
                        }
                    });

                    //showhide noresults
                    //TODO: move selectors to selector params
                    if ($(this.selectors.rows + ':visible', context).length) {
                        $('[data-component-role="noResults"]', context).hide();
                    } else {
                        $('[data-component-role="noResults"]', context).show();
                    }
                };
                gridComponent.pageGrid = function () {
                    alert('do this!');
                };
                gridComponent.sortGrid = function (e) {
                    var el = $(e.target);
                    var context = $(this.selectors.table, this.el);
                    var rows = $(this.selectors.rows, context).get();
                    var sortDescending = el.hasClass('asc');
                    var component = this;

                    $('[data-role="sort-action"]', context).removeClass('asc').removeClass('desc').removeAttr('aria-sort');

                    rows = app.util.mergeSort(rows, el.data('target'));

                    if (sortDescending) {
                        el.addClass('desc');
                        el.attr('aria-sort', 'descending');
                        rows = rows.reverse();
                    } else {

                        el.addClass('asc');
                        el.attr('aria-sort', 'ascending');

                    }

                    if (component.selectors.rows === 'tbody') {
                        $.each(rows, function (index, row) {
                            context.append(row);
                        });
                    }
                    else {
                        $.each(rows, function (index, row) {
                            context.children('tbody').append(row);
                        });
                    }
                };
                $(gridComponent.selectors.filterForm).on('keydown', function () {
                    switch (event.keyCode) {
                        case 13:
                            event.preventDefault();
                            event.stopPropagation();
                    }
                });
            } else {
                gridComponent.filterGrid = function () { this.refreshGrid(); };
                gridComponent.pageGrid = function (e) {
                    var page = $(e.target).data('page-value');
                    this.refreshGrid(page);
                };
                gridComponent.sortGrid = function (e) {
                    var el = $(e.target);
                    var context = $(this.selectors.table, this.el);
                    var sortDescending = el.hasClass('asc');

                    $('[data-role="sort-action"]', context).removeClass('asc').removeClass('desc').removeAttr('aria-sort');

                    if (sortDescending) {
                        el.addClass('desc');
                        el.attr('aria-sort', 'descending');
                    } else {
                        el.addClass('asc');
                        el.attr('aria-sort', 'ascending');
                    }

                    this.refreshGrid();
                };
                gridComponent.checkAll = function (e) {
                    if ($(e.target).prop('checked')) {
                        $("[name*='" + $(e.target).data('name') + "']").prop('checked', true);
                    }
                    else {
                        $("[name*='" + $(e.target).data('name') + "']").prop('checked', false);
                    }
                };
                gridComponent.changeAllDropdown = function (e) {
                    $("[name*='" + $(e.target).data('name') + "']").val($(e.target).val());
                };
                gridComponent.changeAllTextbox = function (e) {
                    $("[name*='" + $(e.target).data('name') + "']").val($(e.target).val());
                };
                gridComponent.refreshGrid = function (pageNumber, otherData) {
                    $(document).trigger("component-filter-grid-started", this);

                    var form = $(this.selectors.filterForm);
                    var pageSize = $(this.selectors.pageSize).val();
                    var el = this.el;
                    var context = $(this.selectors.table, this.el);
                    const $sorted = $('[aria-sort]:not([aria-sort="none"])', context);

                    //get filters
                    var filters = form.serializeArray();
                    var pageNum = pageNumber || 1;
                    filters.push({ name: "pageNumber", value: pageNum });
                    filters.push({ name: "pageSize", value: pageSize });
                    filters.push({ name: "sortField", value: $('[aria-sort]:not([aria-sort="none"])', context).data('target') });
                    filters.push({ name: "isSortAscending", value: $sorted.length === 0 || $sorted.first().attr('aria-sort') === 'ascending'});
                    //This is an option that let's you pass in additional data to the refresh action.
                    //This could be used to create records, do sorting, one time filters etc. Values are not persisted in the filter form.
                    //otherData should be an array with objects as above (name/value)
                    if (otherData) {
                        filters = filters.concat(otherData);
                    }
                    this.startLoading();
                    if (this.request != null) {
                        this.request.abort();
                        this.request = null;
                    }
                    this.request = $.ajax({ url: this.urls.view, data: $.param(filters), context: this, error: this.page.handleAjaxError, type: 'POST' }).done(function (data) {
                        el.html(data);
                        this.endLoading();
                        this.bindViewMode();
                        var forResults = $(this.selectors.showForResults);

                        if (forResults) {
                            if ($('.no-results', this.el).length) {
                                forResults.hide();
                                eval();
                            } else {
                                forResults.show();
                                eval();
                            }
                        }
                    });

                    $(document).trigger("component-filter-grid-completed", this);
                    $(document).trigger("component-filter-grid-completed-" + this.type, this);
                };
            }

            $(gridComponent.componentActions.report).each(function () {
                app.grids.initPageGridAction(this);
            });

            if (gridComponent.state === "active") {
                $('[data-role="sort-action"]', gridComponent.el).on('click', $.proxy(gridComponent.sortGrid, gridComponent));
                $('[data-role="grid-page-action"]', gridComponent.el).on('click', $.proxy(gridComponent.pageGrid, gridComponent));
            }
            //Prevent enter key and escape to prevent unintended form posts
            $('form[data-component-action="filtergrid"] input, form[data-component-action="filtergrid"] select').on('keydown', $.proxy(function () {
                switch (event.keyCode) {
                    case 13:
                        event.preventDefault();
                        event.stopPropagation();
                        break;
                    case 27:
                        event.preventDefault();
                        event.stopPropagation();
                        break;
                }
            }, this));
        },
        initPageGridActions: function () {
            if (app.page.componentActions.report) {
                app.page.componentActions.report.forEach(function (pageAction) {
                    app.grids.initPageGridAction(pageAction);
                });
            }
        },
        initPageGridAction: function (pageAction) {
            switch (pageAction.action) {
                case "filtergrid":
                    pageAction.triggerAction = function (e) {
                        if (e.type !== "keyup" || app.util.isPrintableCharacter(e)) {
                            var delay = 300;
                            if (e.type !== "keyup") {
                                delay = 0;
                            }
                            //if keyup, add a delay
                            if (this.timeout !== null) { clearTimeout(this.timeout); }
                            var that = this;
                            this.timeout = setTimeout(function () {

                                var theTargets = that.target.split(" ");
                                theTargets.forEach(function (theTarget) {
                                    var grids = this.app.page.allComponents[theTarget];
                                    grids.forEach(function (grid) {
                                        grid.filterGrid(e);
                                    });
                                });

                            }, delay, e, that);
                        }
                    };
                    pageAction.el.off(pageAction.event).on(pageAction.event, $.proxy(pageAction.triggerAction, pageAction));
                    break;
                case "viewgridpage":
                    pageAction.triggerAction = function (e) {
                        var target = this.page.components[this.target][0];
                        target.filterGrid($(e.target).data('component-action-value'));
                    };
                    pageAction.el.off(pageAction.event).on(pageAction.event, $.proxy(pageAction.triggerAction, pageAction));
                    break;
            }
        }
    };

    return myGrids;
}());

$(function () {
    app.grids.Init();
});
